import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mobile-application-development',
    templateUrl: './mobile-application-development.component.html',
    styleUrls: ['./mobile-application-development.component.scss'],
    standalone: false
})
export class MobileApplicationDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
